import { NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { ContactRoutingModule } from "./call-center-routing.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FileUploadModule } from "primeng/fileupload";
import { ToastModule } from "primeng/toast";
import { TableModule } from "primeng/table";
import { ToggleButtonModule } from "primeng/togglebutton";
import { DropdownModule } from "primeng/dropdown";
import { ModalModule } from "ngx-bootstrap/modal";
import { PaginatorModule } from "primeng/paginator";
import { DialogModule } from "primeng/dialog";
import { ButtonModule } from "primeng/button";
import { CalendarModule } from "primeng/calendar";
import { MultiSelectModule } from "primeng/multiselect";
import { CodeHighlighterModule } from "primeng/codehighlighter";
import { TabMenuModule } from "primeng/tabmenu";
import { StepsModule } from "primeng/steps";
import { PanelModule } from "primeng/panel";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";
import { AutoCompleteModule } from "primeng/autocomplete";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { CallCenterDetailsComponent } from "./call-center-details/call-center-details.component";
import { RadioButtonModule } from "primeng/radiobutton";
import { CallHistoryComponent } from "./call-history/call-history.component";
import { PatientDashboardComponent } from "./patient-dashboard/patient-dashboard.component";
import { MessageService } from "primeng/api";

@NgModule({
  declarations: [
    CallCenterDetailsComponent,
    CallHistoryComponent,
    PatientDashboardComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RadioButtonModule,
    ContactRoutingModule,
    DropdownModule,
    ModalModule.forRoot(),
    FileUploadModule,
    ToggleButtonModule,
    TableModule,
    ToastModule,
    PaginatorModule,
    DialogModule,
    MultiSelectModule,
    CodeHighlighterModule,
    CalendarModule,
    TabMenuModule,
    StepsModule,
    PanelModule,
    ButtonModule,
    AutoCompleteModule,
    TypeaheadModule.forRoot(),
    BsDatepickerModule.forRoot(),
  ],
  exports: [
    // CallCenterInboundCallComponent,
    // CallCenterDailerComponent
  ],
  providers: [DatePipe, MessageService],
})
export class CallCenterModule {}
